<template>
  <v-dialog
    persistent
    @keydown.esc="closeModal"
    :value="recommendPop"
    max-width="800"
  >
    <v-carousel
      :show-arrows="false"
      v-model="currentModelNo"
      height="auto"
      :light="true"
      :touchless="true"
    >
      <v-carousel-item>
        <v-card>
          <v-card-title>Recommendations</v-card-title>
          <v-container>
            <v-text-field
              v-model="qItemsSearch"
              prepend-inner-icon="mdi-magnify"
              placeholder="Search by Product Name/SKU/Brand/Category"
              v-if="items.length !== 0"
            ></v-text-field>
            <v-sheet
              depressed
              v-if="filteredMenus.length === 0"
              class="ml-5 body-1 grey--text text--darken-2"
              >No Data Found</v-sheet
            >
            <v-card-text v-else class="px-0">
              <div class="list__container background">
                <v-list class="transparent">
                  <v-list-group
                    ref="mainListGroup"
                    :value="false"
                    append-icon=""
                    v-for="menu in filteredMenus"
                    :key="menu.id"
                    :id="menu.id"
                    :disabled="true"
                  >
                    <template v-slot:activator>
                      <v-checkbox
                        :value="menu.id"
                        v-model="getActiveMenus"
                        @click.stop="toggleMenu(menu.id)"
                        hide-details
                        class="my-2 pt-1 custom-checkbox"
                        :indeterminate="
                          activeCatByMenusCount[menu.id] !== undefined &&
                            activeCatByMenusCount[menu.id] > 0 &&
                            activeCatByMenusCount[menu.id] <
                              menu.products.length
                        "
                      ></v-checkbox>
                      <v-list-item-title
                        class="pt-1 ml-12 my-2 d-flex flex-column"
                      >
                        <div
                          class="mb-2 d-flex justify-space-between align-center"
                        >
                          <h4>{{ menu.name }}</h4>
                          <v-list-item-icon
                            class="my-0"
                            @click.stop="handleMainListGroup(menu.id)"
                            style="z-index: 2;"
                          >
                            <v-icon>
                              mdi-menu-down
                            </v-icon>
                          </v-list-item-icon>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <v-spacer />
                          <small>
                            Main Category
                          </small>
                        </div>
                      </v-list-item-title>
                    </template>

                    <v-list-item
                      class="ml-7"
                      v-for="category in menu.products"
                      :key="category.id"
                      :id="category.id"
                    >
                      <!--<template v-slot:activator>-->
                      <v-checkbox
                        hide-details
                        :value="category.id"
                        v-model="getActiveCategories"
                        @click.stop="
                          toggleCategories(
                            category.id,
                            menu.id,
                            menu.products.length
                          )
                        "
                        class="my-2 pt-1 custom-checkbox custom-checkbox-2"
                      ></v-checkbox>
                      <!-- :indeterminate="
                            activeItemsByCatCount[category.id] !== undefined &&
                              activeItemsByCatCount[category.id] > 0 &&
                              activeItemsByCatCount[category.id] <
                                category.variants.length
                          " -->
                      <v-list-item-title
                        class="pt-1 ml-11 my-2 d-flex flex-column"
                      >
                        <div
                          class="mb-2 d-flex justify-space-between align-center"
                        >
                          <h4 class="">{{ category.name }}</h4>
                          <!-- <v-list-item-icon
                              class="my-0"
                              @click.stop="handleSubListGroup(category.id)"
                              style="z-index: 2;"
                            >
                              <v-icon>
                                mdi-menu-down
                              </v-icon>
                            </v-list-item-icon> -->
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <v-spacer />
                          <small class="">
                            Product
                          </small>
                        </div>
                      </v-list-item-title>
                      <!--</template>-->

                      <!-- <v-list-item
                        class="pl-16 ml-3"
                        link
                        :v-if="category.variants"
                        v-for="item in category.variants"
                        :key="item.id"
                      >
                        <v-checkbox
                          :value="item.id"
                          v-model="getActiveSkus"
                          @click.stop="
                            toggle(
                              item,
                              category.id,
                              category.variants.length,
                              menu.id,
                              menu.products.length
                            )
                          "
                          hide-details
                          class="my-2 pt-1 custom-checkbox custom-checkbox-3"
                        ></v-checkbox>
                        <v-list-item-title
                          class="pt-1 ml-11 my-2 d-flex flex-column"
                        >
                          <div class="d-flex justify-space-between align-center">
                            <h4 class="mb-2">{{ item.name }}</h4>
                            <h5 class="grey--text mb-2 font-weight-medium">
                              Original Brand Name
                            </h5>
                          </div>
                          <div class="d-flex justify-space-between align-center">
                            <h4>SKU: {{ item.sku }}</h4>
                            <h5 class="grey--text font-weight-medium">
                              {{ item.short_description }}
                            </h5>
                          </div>
                        </v-list-item-title>
                      </v-list-item> -->
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="filteredMenus.length > 0"
                depressed
                class="float-right"
                color="primary"
                @click="changeModal()"
              >
                Next
              </v-btn>
              <v-btn
                depressed
                class="float-right"
                color="white"
                @click="closeModal()"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-carousel-item>
      <v-carousel-item>
        <v-card>
          <v-card-title>Recommendations</v-card-title>
          <v-container>
            <v-card-text class="px-0 py-0">
              <drag-recommend :activeSkus="activeSkusData" />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                class="float-right"
                color="white"
                @click="closeModal()"
              >
                Close
              </v-btn>
              <v-btn
                depressed
                class="float-right"
                color="primary"
                @click="save()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { CategoryAPI } from '@/clients/product/category.api'
import DragRecommend from './DragRecommend.vue'

export default {
  data() {
    return {
      currentModelNo: 0,
      qItemsSearch: '',
      fetchedRecommendationsSkus: [],
      activeMenu: [],
      activeCategories: [],
      // activeItemsByCatCount: {},
      activeCatByMenusCount: {},
      activeSkusData: [],
      items : []
    }
  },
  components: {
    DragRecommend
  },
  computed: {
    ...mapGetters({
      recommendPop: 'category/recommendPop',
      // vg_items: 'category/menus',
      recommendObj: 'category/recommendObj',
      selectedLocation: 'location/selected'
    }),
    filteredMenus() {
      var textToSearch = this.qItemsSearch.toLowerCase()
      if (!this.qItemsSearch) {
        return this.items
      }
      return this.items.filter(
        menu =>
          menu.name.toLowerCase().includes(textToSearch) ||
          menu.products.find(elem =>
            elem.name.toLowerCase().includes(textToSearch)
          ) ||
          menu.products.find(elem =>
            elem.variants.find(item =>
              item.name.toLowerCase().includes(textToSearch)
            )
          ) ||
          menu.products.find(elem =>
            elem.variants.find(item =>
              item.sku.toLowerCase().includes(textToSearch)
            )
          )
      )
    },
    getActiveCategories: {
      get() {
        return this.activeCategories
      },
      set() {}
    },
    getActiveMenus: {
      get() {
        return this.activeMenu
      },
      set() {}
    },
    getActiveSkus: {
      get() {
        return this.activeSkus
      },
      set() {}
    }
  },
  // async mounted() {
  //   this.spinner(true)
  //   await this.va_fetchMenus(this.selectedLocation.id)
  //   this.spinner(false)
  // },
  watch: {
    async recommendPop(val) {
      this.activeCategories = []
      // this.activeSkus = []
      // this.activeItemsByCatCount = {}
      this.activeMenu = []
      this.activeCatByMenusCount = {}
      this.activeSkusData = []
      if (val === true) {
        await this.getSkus()
        this.spinner(true)
        try {
          const {
            data: { payload }
          } = await CategoryAPI.getMenus(this.selectedLocation.id)
          this.items = payload
          this.spinner(false)
        } catch (err) {
          this.spinner(false)
          console.log(err)
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      va_changeModal: 'category/mutateRecommendPop'
    }),
    // ...mapActions({
    //   va_fetchMenus: 'category/fetchAll'
    // }),

    updateActive() {
      const menus = [...this.items]
      for (let k = 0; k < menus.length; k++) {
        for (let i = 0; i < menus[k].products.length; i++) {
          let category = menus[k].products[i]

          // for (let j = 0; j < category.variants.length; j++) {
          //   let item = category.variants[j]
          //   let index = this.activeSkus.indexOf(item.id)
          //   if (index > -1) {
          //     if (category.id in this.activeItemsByCatCount) {
          //       this.activeItemsByCatCount[category.id] += 1
          //     } else {
          //       this.activeItemsByCatCount[category.id] = 1
          //     }
          //     if (
          //       category.variants.length ===
          //       this.activeItemsByCatCount[category.id]
          //     ) {
          //       this.activeCategories.push(category.id)
          //     }
          //   }
          // }
          let cateIndex = this.activeCategories.indexOf(category.id)
          if (cateIndex > -1) {
            let menuId = menus[k].id
            if (menuId in this.activeCatByMenusCount) {
              this.activeCatByMenusCount[menuId] += 1
            } else {
              this.activeCatByMenusCount[menuId] = 1
            }
            if (
              this.activeCatByMenusCount[menuId] === menus[k].products.length
            ) {
              this.activeMenu.push(menuId)
            }
          }
        }
      }
    },
    toggleMenu(menuId) {
      let index = this.activeMenu.indexOf(menuId)
      if (index > -1) {
        this.activeMenu.splice(index, 1)
        this.activeCatByMenusCount[menuId] = 0
        this.items.forEach(menu => {
          if (menu.id === menuId) {
            menu.products.forEach(category => {
              // this.activeItemsByCatCount[category.id] = 0
              let cateIndex = this.activeCategories.indexOf(category.id)
              if (cateIndex > -1) this.activeCategories.splice(cateIndex, 1)
              // category.variants.forEach(item => {
              //   let ind = this.activeSkus.indexOf(item.id)
              //   if (ind > -1) {
              //     this.activeSkus.splice(ind, 1)
              //   }
              // })
            })
          }
        })
      } else {
        this.activeMenu.push(menuId)
        this.items.forEach(menu => {
          if (menu.id === menuId) {
            this.activeCatByMenusCount[menu.id] = menu.products.length
            menu.products.forEach(category => {
              // this.activeItemsByCatCount[category.id] = category.variants.length
              let cateIndex = this.activeCategories.indexOf(category.id)
              if (cateIndex === -1) this.activeCategories.push(category.id)
              // category.variants.forEach(item => {
              //   let ind = this.activeSkus.indexOf(item.id)
              //   if (ind === -1) {
              //     this.activeSkus.push(item.id)
              //   }
              // })
            })
          }
        })
      }
    },
    toggleCategories(categoryId, menuId, totalCategories) {
      let index = this.activeCategories.indexOf(categoryId)
      if (index > -1) {
        this.activeCategories.splice(index, 1)
        if (this.activeCatByMenusCount[menuId] === totalCategories) {
          let indexMenu = this.activeMenu.indexOf(menuId)
          this.activeMenu.splice(indexMenu, 1)
        }
        this.activeCatByMenusCount[menuId] -= 1
        // managing sku
        // this.activeItemsByCatCount[categoryId] = 0
        // this.vg_items.forEach(menu => {
        //   if (menu.id === menuId) {
        //     menu.products.forEach(category => {
        //       if (category.id === categoryId) {
        //         category.variants.forEach(item => {
        //           let ind = this.activeSkus.indexOf(item.id)
        //           if (ind > -1) {
        //             this.activeSkus.splice(ind, 1)
        //           }
        //         })
        //       }
        //     })
        //   }
        // })
      } else {
        this.activeCategories.push(categoryId)
        if (menuId in this.activeCatByMenusCount) {
          this.activeCatByMenusCount[menuId] += 1
        } else {
          this.activeCatByMenusCount[menuId] = 1
        }
        if (this.activeCatByMenusCount[menuId] === totalCategories) {
          this.activeMenu.push(menuId)
        }
        // managing sku
        // this.vg_items.forEach((menu, index) => {
        //   if (menu.id === menuId) {
        //     menu.products.forEach((category, catIndex) => {
        //       if (category.id === categoryId) {
        //         category.variants.forEach((item, itemIndex) => {
        //           let ind = this.activeSkus.indexOf(item.id)
        //           if (ind === -1) {
        //             this.activeSkus.push(item.id)
        //             this.activeItemsByCatCount[categoryId] += 1
        //           }
        //         })
        //       }
        //     })
        //   }
        // })
      }
    },
    // toggle(value, categoryId, totalItems, menuId, totalCategories) {
    //   let index = this.activeSkus.indexOf(value.id)
    //   if (index > -1) {
    //     this.activeSkus.splice(index, 1)
    //     if (this.activeItemsByCatCount[categoryId] === totalItems) {
    //       let indexCate = this.activeCategories.indexOf(categoryId)
    //       this.activeCategories.splice(indexCate, 1)
    //       if (menuId in this.activeCatByMenusCount) {
    //         this.activeCatByMenusCount[menuId] -= 1
    //         let menuInd = this.activeMenu.indexOf(menuId)
    //         if (menuInd > -1) this.activeMenu.splice(menuInd, 1)
    //       }
    //     }
    //     this.activeItemsByCatCount[categoryId] -= 1
    //   } else {
    //     this.activeSkus.push(value.id)
    //     if (categoryId in this.activeItemsByCatCount) {
    //       this.activeItemsByCatCount[categoryId] += 1
    //     } else {
    //       this.activeItemsByCatCount[categoryId] = 1
    //     }
    //     if (this.activeItemsByCatCount[categoryId] === totalItems) {
    //       this.activeCategories.push(categoryId)
    //       if (menuId in this.activeCatByMenusCount) {
    //         this.activeCatByMenusCount[menuId] += 1
    //       } else {
    //         this.activeCatByMenusCount[menuId] = 1
    //       }
    //       if (this.activeCatByMenusCount[menuId] === totalCategories) {
    //         this.activeMenu.push(menuId)
    //       }
    //     }
    //   }
    // },
    closeModal() {
      this.va_changeModal(false)
      this.currentModelNo = 0
      if (this.$refs.mainListGroup) {
        this.$refs.mainListGroup.forEach(element => {
          if (element.isActive) {
            element.isActive = false
          }
        })
      }
      if (this.$refs.subListGroup) {
        this.$refs.subListGroup.forEach(element => {
          if (element.isActive) {
            element.isActive = false
          }
        })
      }
      this.items = []
    },
    async changeModal() {
      try {
        this.spinner(true)
        if (
          this.activeCategories.sort().join(',') !==
          this.fetchedRecommendationsSkus.sort().join(',')
        ) {
          const {
            data: { payload }
          } = await CategoryAPI.postSkus(
            this.activeCategories,
            this.recommendObj
          )
          this.activeSkusData = payload
        }
        this.spinner(false)
        this.currentModelNo += 1
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.errors
            ? err.response.data.errors[0]
            : err.response.data.msg,
          open: true,
          color: 'error'
        })
      }
    },
    save() {
      this.closeModal()
    },
    handleMainListGroup(menuId) {
      this.$refs.mainListGroup.forEach(element => {
        if (element.attrs$.id === menuId) {
          if (!element.isActive) {
            element.isActive = true
          } else if (element.isActive) {
            element.isActive = false
          }
        }
      })
    },
    handleSubListGroup(catId) {
      this.$refs.subListGroup.forEach(element => {
        if (element.attrs$.id === catId) {
          if (!element.isActive) {
            element.isActive = true
          } else if (element.isActive) {
            element.isActive = false
          }
        }
      })
    },
    async getSkus() {
      try {
        this.spinner(true)
        let {
          data: { payload }
        } = await CategoryAPI.getSkus(this.recommendObj)
        const activeSkusRawData = payload[0].categoryRecommendationProducts
        let activeIds = []
        for (let i = 0; i < activeSkusRawData.length; i++) {
          this.activeCategories.push(activeSkusRawData[i].id)
        }
        this.fetchedRecommendationsSkus = [...this.activeCategories] || []
        this.activeSkusData = activeSkusRawData
        this.updateActive()
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.errors
            ? err.response.data.errors[0]
            : err.response.data.message,
          open: true,
          color: 'error'
        })
      }
    }
  }
}
</script>
<style>
.v-carousel__controls {
  display: none;
}
</style>
<style scoped>
.list__container {
  height: 50vh;
  overflow-y: auto;
}
.custom-checkbox {
  position: absolute;
  z-index: 1;
  padding-top: 0px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  background-color: transparent;
}
</style>
